import { validateNumber } from 'ember-changeset-validations/validators';

export const ChannelCommissionValidation = {
  amount: [validateNumber({ gte: -100, lte: 100 })],
};
